module.exports = __webpack_public_path__ + "static/img/phone2-cutted.fe29bc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone2-cutted.png
// module id = n4G1
// module chunks = 0